import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "search-filter__choices" };
const _hoisted_3 = ["title"];
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = {
    key: 1,
    class: "search-filter__choices-dropdown-item search-filter__choices-dropdown-item--loading"
};
const _hoisted_6 = {
    key: 2,
    class: "search-filter__choices-dropdown-item search-filter__choices-dropdown-item--error"
};
const _hoisted_7 = ["onClick", "onKeydown"];
import { ref, computed, watch, onMounted } from 'vue';
import Icon from "./Icon.vue";
import paloma from '../services/PalomaBackend';
import log from "../services/Logger";
import Spinner from "./Spinner.vue";
const filterSearchThreshold = 15;
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchFilterSelect',
    props: {
        filter: {},
        choices: {},
        showChoicesDropdown: { type: Boolean },
        selected: { type: Boolean }
    },
    emits: [
        'change'
    ],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const focus = () => {
            if (inputRef.value !== null) {
                inputRef.value.focus();
            }
            else {
                divRef.value?.focus();
            }
        };
        __expose({
            focus
        });
        const choicesFilter = ref(null);
        const divRef = ref(null);
        const inputRef = ref(null);
        const loading = ref(false);
        const errorKey = ref(null);
        function toggleChoice(choice) {
            if (choiceSelected(choice)) {
                props.choices.splice(props.choices.indexOf(choice.value), 1);
            }
            else {
                props.choices.push(choice.value);
            }
            emit('change');
        }
        function choiceSelected(choice) {
            return props.choices.indexOf(choice.value) !== -1;
        }
        const choicesStr = computed(() => {
            if (props.choices.length === 0) {
                return '';
            }
            return props.choices
                .map(v => {
                const _choices = props.filter.filter.choices;
                const choice = Array.isArray(_choices) ? _choices.find(c => c.value === v) : undefined;
                return (choice && choice.label) || v;
            })
                .reduce((l1, l2) => l1 + ', ' + l2);
        });
        const availableChoices = computed(() => {
            if (loadedChoices.value) {
                return loadedChoices.value;
            }
            const _choices = props.filter.filter.choices;
            if (!Array.isArray(_choices)) {
                return [];
            }
            return _choices;
        });
        const choicesUrl = computed(() => {
            // check filter choices for choices URL
            if (!Array.isArray(props.filter.filter.choices)
                && props.filter.filter.choices
                && props.filter.filter.choices.hasOwnProperty('url')) {
                return props.filter.filter.choices.url;
            }
            return null;
        });
        watch(choicesUrl, loadChoices);
        onMounted(loadChoices);
        const loadedChoices = ref(null);
        const filteredChoices = computed(() => {
            const choices = availableChoices.value
                .filter(choice => {
                return !choicesFilter.value
                    || (choice.label && choice.label.toLowerCase().indexOf(choicesFilter.value.toLowerCase()) !== -1)
                    || (choice.value && choice.value.toLowerCase().indexOf(choicesFilter.value.toLowerCase()) !== -1);
            });
            if (choices.length >= filterSearchThreshold) {
                return choices
                    .sort((c1, c2) => {
                    const c1Selected = choiceSelected(c1);
                    const c2Selected = choiceSelected(c2);
                    if (c1Selected === c2Selected) {
                        return 0;
                    }
                    if (c1Selected) {
                        return -1;
                    }
                    return 1;
                });
            }
            return choices;
        });
        function loadChoices() {
            const url = choicesUrl.value;
            if (!url) {
                return;
            }
            log('Loading choices from ' + url);
            loadedChoices.value = null;
            errorKey.value = null;
            loading.value = true;
            paloma.http.get(url)
                .then(response => {
                loadedChoices.value = Array.isArray(response.data)
                    ? response.data
                    : response.data['content']; // assume Page<T>
            })
                .catch(e => {
                errorKey.value = e?.response?.status === 403
                    ? 'search.filter.options_forbidden'
                    : 'search.filter.options_unavailable';
                log('Failed to load filter choices', e);
            })
                .finally(() => loading.value = false);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "divRef",
                ref: divRef,
                id: 'filter' + __props.filter.id,
                class: _normalizeClass({
                    'search-filter--active': __props.selected,
                    'search-filter--special': __props.filter.filter.category === 'special',
                    'search-filter--show-choices-dropdown': __props.selected && __props.showChoicesDropdown,
                }),
                tabindex: "0"
            }, [
                _createElementVNode("div", _hoisted_2, [
                    (__props.choices.length > 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "search-filter__selected-choices",
                            title: choicesStr.value
                        }, _toDisplayString(choicesStr.value), 9, _hoisted_3))
                        : _createCommentVNode("", true),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("span", null, [
                        _createVNode(Icon, {
                            name: __props.showChoicesDropdown ? 'angle-up' : 'angle-down'
                        }, null, 8, ["name"])
                    ])
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"])),
                    class: "search-filter__choices-dropdown"
                }, [
                    (Array.isArray(__props.filter.filter.choices) && __props.filter.filter.choices.length >= filterSearchThreshold)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "search-filter__choices-search",
                            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => { }, ["exact", "stop"]), ["delete"]))
                        }, [
                            _withDirectives(_createElementVNode("input", {
                                ref_key: "inputRef",
                                ref: inputRef,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((choicesFilter).value = $event)),
                                placeholder: _ctx.$t('search.placeholder')
                            }, null, 8, _hoisted_4), [
                                [_vModelText, choicesFilter.value]
                            ])
                        ], 32))
                        : _createCommentVNode("", true),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(Spinner, { loading: true })
                        ]))
                        : _createCommentVNode("", true),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    (errorKey.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(Icon, { name: "warning" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(errorKey.value)), 1)
                        ]))
                        : _createCommentVNode("", true),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredChoices.value, (choice) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: choice.value,
                            onClick: _withModifiers(($event) => (toggleChoice(choice)), ["prevent"]),
                            onKeydown: _withKeys(_withModifiers(($event) => (toggleChoice(choice)), ["exact", "prevent", "stop"]), ["enter"]),
                            class: _normalizeClass(["search-filter__choices-dropdown-item", { 'search-filter__choices-dropdown-item--active': choiceSelected(choice) }]),
                            tabindex: "0"
                        }, [
                            _createVNode(Icon, {
                                name: choiceSelected(choice) ? 'check-square' : 'square'
                            }, null, 8, ["name"]),
                            _createTextVNode(" " + _toDisplayString(choice.label), 1)
                        ], 42, _hoisted_7));
                    }), 128))
                ])
            ], 10, _hoisted_1));
        };
    }
});
